import { __decorate } from "tslib";
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import { emit } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/event.js';
import styles from './backdrop.scss.js';
/**
 * @element cipublic-backdrop
 */
export class Backdrop extends CipublicElement {
    constructor() {
        super(...arguments);
        this.active = false;
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        document.body.classList.toggle('backdrop-active', this.active);
        emit(this, `backdrop.${this.active ? 'opened' : 'closed'}`);
    }
    static get styles() {
        return [styles];
    }
}
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'active' })
], Backdrop.prototype, "active", void 0);
//# sourceMappingURL=backdrop.js.map